import React from 'react';
import Header from './Header';
import Sidebar from './Sidebar';
import './Layout.scss';

const Layout = ({ children, activeSection, onSectionChange }) => {
    return (
        <div className="admin-layout">
            <Header />
            <div className="layout-content">
                <Sidebar
                    activeSection={activeSection}
                    onSectionChange={onSectionChange}
                />
                <main className="main-content">
                    {children}
                </main>
            </div>
        </div>
    );
};

export default Layout;